export const BLOGS_DATA = [
  {
    id: "1",
    title: "Why Reliable Plumbing is Necessary?",
    src: "https://res.cloudinary.com/du1euxdon/image/upload/v1677491626/img_ypngqy.jpg",
    desc: "Consider how difficult it would be to begin each day with leaking pipes that were causing walls to collapse, causing mold and fungus to grow, and clogging sinks and toilets. These problems not only bother you an",
    link: "Why-Reliable-Plumbing-is-Necessary?",
  },
  {
    id: "2",
    title: "The Future of Drainage Piping Systems Delivered Today",
    src: "https://res.cloudinary.com/dmbpo49ak/image/upload/v1677758302/RAKtherm/FOR-WERBSITE_tnp6ty.jpg",
    desc: "With RAKtherm’s Multilayer Drainage Piping Solutions, we have thoroughly understood piping systems to distribute waste water efficiently. Our in-depth research and development have allowed us to develop a contemporary approach to analyzing piping networks over the past 60 years.",
    link: "The-Future-of-Drainage-Piping-Systems-Delivered-Today",
  },
  {
    id: "3",
    title: "Innovator of UV Fittings System",
    src: "https://www.raktherm.com/images/blog3.jpeg",
    desc: "Anti-UV piping systems are better than regular ones in situations exposed to sunlight. That's because ultraviolet (UV) rays from the sun can cause damage to many types of plastics, including those used in pipes.    ",
    link: "Innovator-of-UV-Fittings-System",
  },
  {
    id: "4",
    title: "Raktherm Emerges as an Industry",
    src: "https://www.raktherm.com/images/blog4.jpg",
    desc: "RAKtherm Multilayer Drainage Piping Solutions has thoroughly understood piping systems to distribute waste efficiently. Our in-depth research and development have allowed us to develop a contemporary approach to analyzing piping networks over the past 60 years. Since we are the leading innovator and provider of piping solutions in the industry, we are dedicated to providing high-quality goods and services.",
    link: "Raktherm-Emerges-as-an-Industry",
  },
  {
    id: "5",
    title: "Innovative U-Loop Expansion for Potable Water Line",
    src: "https://www.raktherm.com/images/building.png",
    desc: "NSHAMA Development LLC, a prominent real estate developer in Dubai, engaged Shapoorji Pallonji Mideast LLC to construct a new residential building of two parallel towers. The project faced a significant challenge in providing multiple expansion joints for the potable water line between the two buildings.",
    link: "Innovative-U-Loop-Expansion-for-Potable-Water-Line",
  },
];
